import React from 'react';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import Skeleton from '@mui/material/Skeleton';

const StyledBox = styled(Box)(({ theme }) => ({
  maxWidth: theme.typography.pxToRem(600),
  margin: 'auto',
  '& .HISBenfitsSkeleton': {
    padding: theme.spacing(2),
    margin: theme.spacing(3, 0),
    borderRadius: theme.spacing(2),
    border: `1px solid ${theme.palette.secondary.light}`,
    textAlign: 'center',
  },
  '& .MuiSkeleton-root': {
    margin: 'auto',
  },
}));

const PlanSectionSkeleton = () => (
  <StyledBox>
    <Skeleton variant="text" width="100%" height={80} />

    <Box className="HISBenfitsSkeleton">
      <Skeleton variant="text" width="190px" height={50} />
      <Skeleton variant="text" width="200px" height={70} />
      <Skeleton variant="text" width="200px" height={50} />
      <Skeleton variant="text" width="80%" height={30} />
      <Skeleton variant="text" width="80%" height={30} />
      <Skeleton variant="text" width="80%" height={30} />
      <Skeleton variant="text" width="80%" height={30} />
      <Skeleton variant="text" width="80%" height={30} />
      <Skeleton variant="text" width="80%" height={30} />
    </Box>
    <Skeleton variant="text" width="100%" height={30} />
    <Skeleton variant="text" width="100%" height={50} />
  </StyledBox>
);
export { PlanSectionSkeleton };
